import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth/auth.interceptor';
import { MapperModule } from '@dynamic-mapper/angular';
import { MAPPING_PROFILES } from './core/mappings/mapping-profiles';
import { provideFirebaseApp, initializeApp, } from '@angular/fire/app';
import { environment } from 'src/environments/environment';
import { AngularFireModule, } from '@angular/fire/compat';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IconModule } from './icon.module';
import { PlatformModule } from '@angular/cdk/platform';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnboardingComponent } from './view/onboarding-container/onboarding/onboarding.component';
import { MaterialModule } from './material.module';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { OnboardingHomeComponent } from './view/onboarding-container/onboarding-home/onboarding-home.component';
import { MatCardModule } from '@angular/material/card';
import { NewBusinessComponent } from './view/onboarding-container/new-business/new-business.component';
import { TermsComponent } from './view/onboarding-container/terms/terms.component';
import { PrivacyComponent } from './view/onboarding-container/privacy/privacy.component';
import { MailOnboardingComponent } from './view/onboarding-container/mail-onboarding/mail-onboarding.component';
import { StylistOnboardingComponent } from './view/onboarding-container/stylist-onboarding/stylist-onboarding.component';
import { ClientOnboardComponent } from './view/onboarding-container/client-onboard/client-onboard.component';
import { NgxStripeModule } from 'ngx-stripe';
import { FreeOnboardComponent } from './view/onboarding-container/free-onboard/free-onboard.component';
import { PaymentComponent } from './view/onboarding-container/payment/payment.component';
import {MatRadioModule} from '@angular/material/radio';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';



const STRIPE_PUBLISHABLE_KEY = environment.STRIPE_KEY
@NgModule({
  declarations: [
    AppComponent,
    OnboardingComponent,
    OnboardingHomeComponent,
    NewBusinessComponent,
    TermsComponent,
    PrivacyComponent,
    MailOnboardingComponent,
    StylistOnboardingComponent,
    ClientOnboardComponent,
    FreeOnboardComponent,
    PaymentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MapperModule.withProfiles([...MAPPING_PROFILES]),
    AngularFireModule.initializeApp(environment.firebase),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    IconModule,
    PlatformModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatFormFieldModule,
    NgxMatIntlTelInputComponent,
    MatCardModule,
    MatStepperModule,
    MatRadioModule,
    NgxStripeModule.forRoot(STRIPE_PUBLISHABLE_KEY),
    NgxMatSelectSearchModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: 'Window',
      useValue: window
    },
    {
      provide: ScrollingModule,
      useValue: {
        momentum: false,
      },
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
